// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutSeason_wrapper__3ez5k","container":"AboutSeason_container__u7Ghb","li":"AboutSeason_li__OvObk"};